import { BackendModel, BackendService } from '../../core/backend.service';
import { CategoriaProducto } from '../categoria-producto/categoria-producto.model';

export class Sugerencia extends BackendModel {

  static path = '/productos/sugerencias/';

  id: number;
  description: string;
  origen: string;

  constructor(protected backendService: BackendService, model?: Sugerencia) {
    super(backendService, model);
  }

  interna() {
    return this.origen === CategoriaProducto.codInterna;
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/sugerencia/sugerencia.model.ts